export const cashFlowProtectionBenefits = [
  {
    label:
      "Life long security for your family with Income + Protection For 100 Years",
  },
];

export const gcapBenefits = [
  { label: "No suprises, only guaranteed returns" },
  {
    label:
      "Get little extra with additional benefits through 'Guaranteed Accrual Additions'",
  },
  {
    label:
      "Flexibility as per your need in policy term and premium paying term ",
  },
];

export const singlePayEndowmentBenefits = [
  {
    label: "No suprises, only guaranteed returns",
  },
  {
    label:
      "No worrying about multiple payments. Pay only once and enjoy the guaranteed returns",
  },
  {
    label: "Added advantage with an enhanced life cover",
  },
];

export const foreverPensionBenefits = [
  {
    label: "Get Guaranteed regular annuity for life",
  },
  {
    label:
      "Select desired annuity option from a range of annuity options (immediate or deferred)",
  },
  {
    label: "Option to cover second life under the same annuity plan",
  },
];

export const posSaralNiveshBenefits = [
  { label: "No surprises, as all your benefits are guaranteed" },
  {
    label:
      "Better rewards when you opt for a higher Sum Assured, discounts, ranging from 3% to 13% ",
  },
];

export const criticareBenefits = [
  { label: "Stay protected against 17 Critical Illness" },
  { label: "Lump sum benefit on the diagnosis of Critical Illness" },
  { label: "Claim three times during the policy term under multiclaim option" },
  {
    label:
      "Get waiver of future premiums on occurrence of first claim and stay protected for the remaining term of the policy",
  },
];

export const wealthUltimaBenefits = [
  { label: "Option to grow your wealth steadily & systematically" },
  { label: "Protect your child's dream with little champ benefit option" },
  { label: "Stay forever protected with life cover upto age 100" },
];

export const wealthPremierBenefits = [
  { label: "No hassle of multiple payments as you pay only once" },
  {
    label:
      "Include your loved ones into your plan through the Joint Life Option",
  },
  {
    label:
      "Make partial withdrawals from your fund value to fulfill your needs",
  },
];

export const aipBenefits = [
  { label: "Enjoy the benefits of life insurance and regular income" },
  { label: "Added security blanket for the family with FIB option" },
  { label: "Enhance your plan with mutiple riders" },
];

export const posForeverPensionBenefits = [
  { label: "Guaranteed regular annuity for life" },
  {
    label:
      "Select desired annuity option from a range of annuity options (immediate or deferred)",
  },
  {
    label: "Option to cover second life under the same annuity plan",
  },
];

export const gssLumpsumIncomeBenefits = [
  {
    label: "Payout flexibility to make it easy for you to fulfil future goals",
  },
  {
    label:
      "Enhanced life cover to cater to your family's future financial protection",
  },
  { label: "Achieve long term savings & protection goals" },
];

export const pgsBenefits = [
  {
    label:
      "Flexibility to customise your plan with various Policy Term, Premium Payment Term options, and Lumpsum Benefit at Maturity",
  },
  {
    label: "Option of riders to enhance your protection",
  },
  {
    label: "Get Income that grows with your plan",
  },
];

export const incomeBuilderBenefits = [
  {
    label:
      "With One plan get Two benefits - regular income as well as a life cover",
  },
  { label: "Option of Two plans- Base plan or Secured Income plan" },
  {
    label:
      "Flexibility to receive income on the day of the month of your choice",
  },
];

export const zindagiProtectLCOBenefits = [
  {
    label:
      "Coverage as per your need. Option to get cover for a limited period or for entire lifetime of up to  100 years",
  },
  { label: "Complete Protection by securing dependents with optional cover" },
  {
    label:
      "Get back the total premiums paid on voluntary exit at a specific point of policy",
  },
];

export const posGSSBenefits = [
  { label: "Payout flexibility to make it easy for you to fulfil future goals" },
  { label: "Enhanced life cover to cater to your family's future financial protection" },
  { label: "Achieve long term savings & protection goals" },
];

export const fspFlexiIncomeAndProBenefits = [
  { label: "Flexibility to customise your plan with various Policy Term, Premium Payment Term options, and accrual of survival benefits" },
  { label: "Option of riders to enhance your protection" },
  { label: "Get Income that starting as early as 2nd policy year till end of policy term along with Maturity Benefit" },
  { label: "Extend your life cover beyond Policy tem with Life Cover Continuation Benefit" },
];

export const fspLargeSumBenefits = [
  { label: "Get Lumpsum at Maturity" },
  { label: "Extend your life cover beyond Policy tem with Life Cover Continuation Benefit" },
];
export const bssBenefits = [
  {
    label:
      "Builds a second income along with 10% cashbacks during premium payment term",
  },
  {
    label:
      "Enjoy all benefits even if you cannot pay the premium for up to 2 years",
  },
  {
    label: "Complete flexibility to receive pay-outs as and when you need them",
  },
];
export const activePensionPlusBenefits = [
  { label: "Get guaranteed annuity throughout the life of the Annuitant" },
  { label: "100% Return of Purchase Price" },
  { label: "Customise your plan with the option to convert annuity amount into the Accrual of Annuity Benefits" }
];
